import Cookies from 'js-cookie';

export class JsCookieHelper {
	setCookie(name: string, value: string, expireInDays?: number): void {
		Cookies.set(name, value, {
			expires: expireInDays
		});
	}

	deleteCookie(name: string): void {
		Cookies.remove(name);
	}

	getCookie(name: string): string | undefined {
		return Cookies.get(name);
	}

	parseHeaderCookiesToObject(cookieString: string | undefined): { [key: string]: string | undefined } {
		// Return an empty object if cookieString
		if (!cookieString || cookieString === '') return {};

		// Get each individual key-value pairs
		// from the cookie string
		// This returns a new array
		const pairs = cookieString.split(';');

		// Separate keys from values in each pair string
		// Returns a new array which looks like
		// [[key1,value1], [key2,value2], ...]
		const splittedPairs = pairs.map((cookie) => cookie.split('='));

		// Create an object with all key-value pairs
		const cookieObj = splittedPairs.reduce((obj: any, cookie) => {
			// cookie[0] is the key of cookie
			// cookie[1] is the value of the cookie
			// decodeURIComponent() decodes the cookie
			// string, to handle cookies with special
			// characters, e.g. '$'.
			// string.trim() trims the blank spaces
			// auround the key and value.
			obj[decodeURIComponent(cookie[0].trim())] = decodeURIComponent(cookie[1].trim());

			return obj;
		}, {});

		return cookieObj;
	}
}

export const jsCookieHelper = new JsCookieHelper();
